/**
 * PublicRoute Component
 * 인증되지 않은 사용자만 접근 가능한 라우트 (로그인 페이지 등)
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { getItem } from '@/shared/utils/storage';

interface PublicRouteProps {
  children: React.ReactElement;
}

/**
 * 인증되지 않은 사용자만 접근 가능한 라우트
 * 이미 인증된 사용자는 대시보드로 리다이렉트
 */
const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const userId = getItem<string>('USER_ID');
  
  // 이미 인증된 경우 대시보드로 리다이렉트
  if (userId) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

export default PublicRoute;

